import { httpClient } from 'core/net/http';
import * as v from 'valibot';
import { LogManager } from 'core/logging/LogManager';

const logger = LogManager.getLogger('fetchModelTypeConfiguration', { error: { logToServer: true } });

export async function fetchModelTypeConfiguration() {
  const response = await httpClient.useInternalApi.asAuthorised().get('/configuration/blasting/model-types');

  if (!response.isSuccess) {
    const errorMessage = 'Failed to fetch model type configuration';
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }

  const parsedResponseData = v.safeParse(ModelTypeConfigSchema, response.data);

  if (!parsedResponseData.success) {
    const errorMessage = 'Failed to parse model type configuration response';
    logger.error(errorMessage, parsedResponseData.issues);
    throw new Error(errorMessage);
  }

  const parsedData = v.safeParse(ParsedModelTypeConfigSchema, {
    flyrock: JSON.parse(parsedResponseData.output.flyrock ?? '{ Kv: null, DispersalAngle: null }'),
    groundVibration: JSON.parse(parsedResponseData.output.groundVibration ?? '{ Kv: null, Kb: null }'),
  });

  if (!parsedData.success) {
    const errorMessage = 'Failed to parse "parsed" model type configuration';
    logger.error(errorMessage, parsedData.issues);
    throw new Error(errorMessage);
  }

  return parsedData.output;
}

const ModelTypeConfigSchema = v.object({
  flyrock: v.nullable(v.string()),
  groundVibration: v.nullable(v.string()),
});

const ParsedModelTypeConfigSchema = v.object({
  flyrock: v.object({
    Kv: v.nullable(v.number()),
    DispersalAngle: v.nullable(v.number()),
  }),
  groundVibration: v.object({
    Kv: v.nullable(v.number()),
    Kb: v.nullable(v.number()),
  }),
});
